var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.882,
    height: 24,
    viewBox: "0 0 22.882 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screenshot-at-Sep-16-22-01-22",
    transform: "translate(-44.005 345.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_893",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 893",
    d: "M48.414-344.867c-.246.135-4.171,4.06-4.3,4.3a1.222,1.222,0,0,0,.056,1.128,1.18,1.18,0,0,0,1.367.358,14.1,14.1,0,0,0,1.232-1.128l1.049-1.049v6.507c0,7.326-.048,6.809.62,7.127a.96.96,0,0,0,1.192-.207l.294-.262.04-6.563L50-341.22l.993,1c1.081,1.081,1.279,1.224,1.708,1.224a1.083,1.083,0,0,0,.961-1.573c-.143-.254-4.068-4.171-4.314-4.3A1.358,1.358,0,0,0,48.414-344.867Z",
    transform: "translate(0 -0.098)",
    fill: "#f27281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_894",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 894",
    d: "M257.587-344.893a1.085,1.085,0,0,0,.1,1.875,1.063,1.063,0,0,0,1.549-.961A1.076,1.076,0,0,0,257.587-344.893Z",
    transform: "translate(-196.158 0)",
    fill: "#4dc7b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_895",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 895",
    d: "M257.725-303.758a1.089,1.089,0,0,0-.016,1.883,1.087,1.087,0,0,0,1.6-.953A1.059,1.059,0,0,0,257.725-303.758Z",
    transform: "translate(-196.233 -37.893)",
    fill: "#4dc7b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_896",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 896",
    d: "M213.367-262.75a1.648,1.648,0,0,0-.437.326l-.2.215-.04,6.547-.04,6.547-.993-1c-1.081-1.081-1.279-1.224-1.708-1.224a1.083,1.083,0,0,0-.961,1.573c.143.254,4.068,4.171,4.314,4.3a1.314,1.314,0,0,0,.922,0c.246-.127,4.171-4.044,4.314-4.3a1.222,1.222,0,0,0-.056-1.128,1.156,1.156,0,0,0-1.422-.318c-.111.072-.652.58-1.208,1.136l-1.017,1v-6.507c0-7.3.04-6.809-.6-7.119A.85.85,0,0,0,213.367-262.75Z",
    transform: "translate(-151.764 -75.676)",
    fill: "#4dc7b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_897",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 897",
    d: "M92.556-110.818a1.172,1.172,0,0,0-.556.961,1.06,1.06,0,0,0,1.581.938A1.089,1.089,0,0,0,93.6-110.8,1.352,1.352,0,0,0,92.556-110.818Z",
    transform: "translate(-44.182 -215.538)",
    fill: "#f27281"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_898",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 898",
    d: "M92.467-69.841a1.077,1.077,0,0,0,.572,1.986,1.058,1.058,0,0,0,1.073-1.073A1.082,1.082,0,0,0,92.467-69.841Z",
    transform: "translate(-44.148 -253.202)",
    fill: "#f27281"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.a94b87291273a1f05ef4ab946fa338cc.svg";
export { ForwardRef as ReactComponent };